export default "__VITE_ASSET__DvG5loNn__"